import { useEffect } from 'react';
import { useTheme } from './useTheme';

/**
 * Writes data-theme (light/dark) + data-color (accent) + lang onto
 * <html> whenever the redux theme state changes, so the CSS-variable
 * token layer in styles/tokens.css takes effect. Renders nothing.
 */
export function ThemeSync() {
  const { mode, accent, lang } = useTheme();

  useEffect(() => {
    const root = document.documentElement;
    const apply = () => {
      const effective =
        mode === 'auto'
          ? window.matchMedia('(prefers-color-scheme: dark)').matches
            ? 'dark'
            : 'light'
          : mode;
      root.setAttribute('data-theme', effective);
      root.setAttribute('data-color', accent);
      root.setAttribute('lang', lang);
    };
    apply();
    if (mode === 'auto') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      mq.addEventListener('change', apply);
      return () => mq.removeEventListener('change', apply);
    }
  }, [mode, accent, lang]);

  return null;
}
